import { HttpContextToken } from "@angular/common/http";
import { hoursToMilliseconds, minutesToMilliseconds, secondsToMilliseconds } from "date-fns";
import { BehaviorSubject, Observable } from "rxjs";

/** Carries RequestCacheConfig.expirationSubject$ to the interceptor (a subject can't be sent as a header like the timer). */
export const CACHE_EXPIRATION_SUBJECT = new HttpContextToken<BehaviorSubject<boolean> | undefined>(() => undefined);

export interface RequestCacheObject<T> {
	observable: Observable<T>
	isExpiredSubject: BehaviorSubject<boolean> | undefined
	expiresAt: number | undefined
}

export class RequestCacheConfig {
	persistenceUnit: 'hours' | 'minutes' | 'seconds' | 'miliseconds' = 'miliseconds'
	persistenceTimer: number
	// While its value is true the cached response is treated as expired
	expirationSubject$: BehaviorSubject<boolean> | undefined

	constructor(persistenceTimer: number = 0, expirationSubject$: BehaviorSubject<boolean> | undefined = undefined, persistenceUnit: 'hours' | 'minutes' | 'seconds' | 'miliseconds' = 'miliseconds') {
		this.persistenceTimer = persistenceTimer;
		this.expirationSubject$ = expirationSubject$;
		this.persistenceUnit = persistenceUnit;
	}

	get persistenceTimerInMs() {
		switch (this.persistenceUnit) {
			case 'hours': 
				return hoursToMilliseconds(this.persistenceTimer);
			case 'minutes':
				return minutesToMilliseconds(this.persistenceTimer);
			case 'seconds':
				return secondsToMilliseconds(this.persistenceTimer);
			case 'miliseconds':
				return this.persistenceTimer;
			default:
				return this.persistenceTimer;
		}
	}
}